// Sort results by chart
const ChartShape = ({
  chartId,
  chartTitle,
  contact,
  chartDescription,
  categories,
  chartNotes,
  states,
  activeKeys,
}) => ({
  chartId,
  chartTitle,
  contact,
  chartDescription,
  categories,
  chartNotes,
  states,
  activeKeys,
});

const ChartStateShape = ({ chartStateId, chartState, topics, activeKeys, stateCode }) => ({
  chartStateId,
  chartState,
  topics,
  activeKeys,
  stateCode,
});

function getChartsArrangedByTopicAndState(chartsState = []) {
  const chartsArrangedByTopicAndState = chartsState.reduce((acc, current, index) => {
    const chartObj = acc.find(item => item.chartId === current.chartId);

    if (chartObj) {
      const existingState = chartObj.states.find(
        item => item.chartStateId === current.chartStateId
      );

      if (existingState) {
        existingState.topics.push(current);
      } else {
        chartObj.states.push(
          ChartStateShape({
            chartStateId: current.chartStateId,
            chartState: current.chartState,
            stateCode: current.stateCode,
            activeKeys: [],
            topics: [current],
          })
        );
      }
    } else {
      acc.push(
        ChartShape({
          chartTitle: current.chartTitle,
          chartId: current.chartId,
          contact: current.contact,
          chartDescription: current.chartDescription,
          categories: current.categories,
          chartNotes: current.chartNotes,
          activeKeys: [index === 0 ? current.chartId.toString() : undefined],
          states: [
            ChartStateShape({
              chartStateId: current.chartStateId,
              chartState: current.chartState,
              stateCode: current.stateCode,
              activeKeys: [],
              topics: [current],
            }),
          ],
        })
      );
    }

    return acc;
  }, []);

  return chartsArrangedByTopicAndState;
}

// Sort search results by state
const StateShape = ({ stateCode, chartState, charts }) => ({
  stateCode,
  chartState,
  charts,
});

const StateChartShape = ({
  chartId,
  chartTitle,
  contact,
  chartDescription,
  categories,
  chartNotes,
  topics,
  chartStateId,
}) => ({
  chartId,
  chartTitle,
  contact,
  chartDescription,
  categories,
  chartNotes,
  topics,
  chartStateId,
});

function getChartsArrangedByState(chartsState = []) {
  const chartsArrangedByState = chartsState.reduce((acc, current, index) => {
    const stateObj = acc.find(item => item.stateCode === current.stateCode);

    if (stateObj) {
      const existingState = stateObj.charts.find(
        item => item.chartStateId === current.chartStateId
      );

      if (existingState) {
        existingState.topics.push(current);
      } else {
        stateObj.charts.push(
          StateChartShape({
            chartId: current.chartId,
            chartTitle: current.chartTitle,
            contact: current.contact,
            chartDescription: current.chartDescription,
            categories: current.categories,
            chartNotes: current.chartNotes,
            chartStateId: current.chartStateId,
            topics: [current],
          })
        );
      }
    } else {
      acc.push(
        StateShape({
          stateCode: current.stateCode,
          chartState: current.chartState,
          charts: [
            StateChartShape({
              chartId: current.chartId,
              chartTitle: current.chartTitle,
              contact: current.contact,
              chartDescription: current.chartDescription,
              categories: current.categories,
              chartNotes: current.chartNotes,
              chartStateId: current.chartStateId,
              topics: [current],
            }),
          ],
        })
      );
    }

    return acc;
  }, []);

  return chartsArrangedByState;
}

function getPaginatedCharts(allCharts = [], currentpage = 1) {
  // eslint-disable-next-line no-param-reassign
  currentpage -= 1;
  return allCharts.slice(currentpage * 10, (currentpage + 1) * 10);
}

// transform saved searches schema to an array
function getSavedSearchesList(savedSearchesObj = {}) {
  return Object.keys(savedSearchesObj).map(searchKey => savedSearchesObj[searchKey]);
}

function getSelectedSearch(searchId, savedSearchesGroup = {}) {
  if (searchId && savedSearchesGroup[searchId]) {
    return savedSearchesGroup[searchId];
  }

  return {
    searchId: null,
    personId: null,
    searchDescription: '',
    categories: [],
    charts: [],
    states: [],
    searchText: '',
    page: null,
    pageSize: null,
    sortField: null,
    sortOrder: null,
  };
}

export {
  getChartsArrangedByState,
  getChartsArrangedByTopicAndState,
  getPaginatedCharts,
  getSavedSearchesList,
  getSelectedSearch,
};